import { makeAutoObservable } from 'mobx';

class SearchStore {
  query = '';
  isOpen = false;

  constructor() {
    makeAutoObservable(this);
  }

  open() {
    this.isOpen = true;
  }

  close() {
    this.isOpen = false;
    this.query = '';
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  setQuery(query: string) {
    this.query = query;
  }
}

export const searchStore = new SearchStore();
